var map = {
	"./D-F.jpg": 34784,
	"./G-J.jpg": 2515,
	"./I1.jpg": 73815,
	"./I2.jpg": 51496,
	"./I3.jpg": 79109,
	"./IF.jpg": 71260,
	"./K-M.jpg": 99604,
	"./N-R.jpg": 91826,
	"./S-Z.jpg": 41127,
	"./SI1-nuevo.jpg": 45358,
	"./SI2.jpg": 64243,
	"./VS1.jpg": 79587,
	"./VS2.jpg": 49876,
	"./WS1.jpg": 77598,
	"./WS2.jpg": 73545,
	"./brillante.jpg": 13856,
	"./corazon.jpg": 27091,
	"./esmeralda.jpg": 87227,
	"./g-h-i.jpg": 22195,
	"./j-k-l-m.jpg": 4726,
	"./marquise.jpg": 37266,
	"./n-o-p-q-r-s-t-u-v-w-x-y-z.jpg": 52643,
	"./oval.jpg": 60813,
	"./pera.jpg": 18759,
	"./si1.jpg": 80004,
	"./si2, si3.jpg": 50384,
	"./vs1, vs2.jpg": 72146,
	"./vvs1, vvs2.jpg": 98002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16410;